var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.themeBlock.name)+"\n  ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(_vm.themeBlock.description)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }